import type { ReactNode } from "react"
import {
  useContext,
  createContext,
} from "react"

export interface OptionAttributes {
  disabled: boolean;
  children: ReactNode;
}

export interface DropdownOptionAttributesContextValue {
  currentSelectionOptionAttributes?: OptionAttributes;
  registerOptionAttributes: (id: string, children: OptionAttributes) => void;
  deregisterOptionAttributes: (id: string) => void;
}

type ContextType = DropdownOptionAttributesContextValue | null
export const DropdownOptionAttributesContext = createContext<ContextType>(null)

export function useDropdownOptionAttributesContext() {
  const context = useContext(DropdownOptionAttributesContext)

  if (context === null) {
    throw new Error("Dropdown components must be wrapped in <DropdownOptionAttributesContext />")
  }

  return context
}
